import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import HTTP from "../../config/ajax";
import Utility from "../../helpers/utility";

export default {
  namespaced: true,
  state: {
    isLoadingTopTenBestsellerAPI : true,
  },
  mutations: {
    updateMultipleRecommendationData(state, payload) {
      const {sequenceSet , name} = payload?.apiPayload ; 
      let key = name ? name : "";
      if(sequenceSet){
        key = key + '_' + sequenceSet ; 
      }

      let actData1=[];
      let actData2=[];

      try{
        let tempData = Utility.keybasedProductItem([{data: payload.response.data}])?.response;
        for (const [key, value] of Object.entries(tempData)) {
          actData1.push(value?.data);
        }
        for (const element in actData1[0]) {
          actData2.push(actData1[0][element]);
        }
      }
      catch(err){
        actData2 =[];
      }
      state[key] =   actData2?.length ? actData2 :[] ;
    },
    setIsLoadingLoadingTopTenBestsellerAPI(state, payload) {
      state.isLoadingTopTenBestsellerAPI = payload;
    },
  },
  actions: {
    getMultipleRecommendationData({ commit }, payload) {
      commit("setIsLoadingLoadingTopTenBestsellerAPI", true);
      apiCalls
        .GET_MULTIPLE_RECOMMENDATION_API({
          headers: Headers(),
          payload: {
            "api" : payload?.api,
            "apiPayload" : {
              ...payload?.apiPayload,
              "storeId" : LocalStorageFunc.storeId()
            },
            "payloadObj" : payload.payloadObj
          }
        })
        .then(function (response) {
          if (response?.data?.data) {
            commit("updateMultipleRecommendationData", {
              "response" : response?.data,
              "apiPayload" : payload?.apiPayload
            });
          }
        })
        .catch(function (error) {})
        .finally(function() {
          commit("setIsLoadingLoadingTopTenBestsellerAPI", false);
        })
    },
  },
};
